module.exports = __webpack_public_path__ + "am.8b42c952.svg";